export default function PHP_empty() {
  return (
    <div>
      <h1>PHP_empty</h1>
    </div>
  );
}
